module.exports={"Clear search":"Rensa sökning"};